var view = require('./marketingPreferencesView');

function view_marketingOptInToggled() {
    view.toggleMarketingContactMethods();
    view.deselectAllContactMethods();
    if (!view.isOptedInToMarketing()) {
        view.validate();
    }
}

function initialize() {
    view.onMarketingOptInToggled(view_marketingOptInToggled);
    view.onContactMethodUpdated(view.validate);

    if (!view.isOptedInToMarketing()) {
        view.toggleMarketingContactMethods();
    }
}

module.exports = {
    initialize: initialize
};